import { render, staticRenderFns } from "./MedicineDispatchDetailDispatch.vue?vue&type=template&id=fafa4a5e"
import script from "./MedicineDispatchDetailDispatch.vue?vue&type=script&lang=js"
export * from "./MedicineDispatchDetailDispatch.vue?vue&type=script&lang=js"
import style0 from "./MedicineDispatchDetailDispatch.vue?vue&type=style&index=0&id=fafa4a5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports